import { useStore } from "csi/state/hooks";
import { Button, FlexColumn, PaneHeader, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import { EnviornmentLighting } from "./EnvironmentLighting";
import { useLocale } from "designSystem/locale";
import SaveEnvironments from "./SaveEnvironments";
import AddIcon from "@mui/icons-material/Add";

export const ThreeDLighting = observer(() => {
	const { rightPaneStore, threeDStore: { environmentsStore, has3DLibraryAdminRole } } = useStore();
	const { closeSelected } = rightPaneStore;
	const loc = useLocale();
	const {
		onNew3DEnvironment,
	} = environmentsStore;

	return (
		<FlexColumn>
			<PaneHeader
				onClose={closeSelected}
				titleRes="3DLighting"
			/>
			<Text
				padding={3}
				paddingBottom={0}
				res="ThreeDEnvironment.Plural"
				variant="h5"
			/>
			{has3DLibraryAdminRole && (
				<Button
					design="outline"
					onClick={onNew3DEnvironment}
					res="New_Name"
					resParams={[loc.type("ThreeDEnvironment")]}
					startIcon={<AddIcon />}
					sx={{
						margin: "12px",
						marginBottom: "0",
						width: "150px",
					}}
				/>
			)}
			<EnviornmentLighting />
			{has3DLibraryAdminRole && 
				<SaveEnvironments />
			}
		</FlexColumn>
	);
});

export default ThreeDLighting;